// libs
import React, { forwardRef } from 'react';

// types
import { BoxProps } from './types';

const Box = forwardRef<HTMLDivElement, BoxProps>((props, ref) => {
  const { component: Component = 'div', onLayout, ...rest } = props;
  return <Component ref={ref} {...rest} />;
});

Box.displayName = 'Box';

export default Box;
